import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress Radix UI focus-related errors on mobile Safari
// These are internal Radix focus management errors, not actual app bugs
if (typeof window !== 'undefined') {
  const originalError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (error && error.stack && error.stack.includes('focus')) return true;
    if (typeof message === 'string' && message === 'Script error.') return true;
    if (originalError) return originalError(message, source, lineno, colno, error);
    return false;
  };
  window.addEventListener('error', function(event) {
    if (event.error && event.error.stack && event.error.stack.includes('focus')) {
      event.preventDefault();
      event.stopPropagation();
      return true;
    }
    if (event.message === 'Script error.') {
      event.preventDefault();
      event.stopPropagation();
      return true;
    }
  }, true);
  window.addEventListener('unhandledrejection', function(event) {
    const reason = event.reason;
    if (reason && typeof reason === 'object' && reason.stack && reason.stack.includes('focus')) {
      event.preventDefault();
      return;
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
